/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    // Add Consent
    getMasterTemplateDesign(params) {
        return HttpService.get(environment.API_MASTGER_TEMPLATE_DESIGN, {
            params,
        });
    },
    getConsentPublished(params) {
        return HttpService.get(environment.API_CONSENT_PUBLISHED, {
            params,
        });
    },
    saveTemplateConsent(payload) {
        return HttpService.post(
            environment.API_TEMPLATE_DESIGN_CONSENT,
            payload
        );
    },
    updateTemplateConsent(payload) {
        return HttpService.put(
            environment.API_TEMPLATE_DESIGN_CONSENT,
            payload
        );
    },
    getTemplateWishKey(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN + '/consent/' + templateKey
        );
    },
    getTemplateConsent(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_CONSENT + '/' + templateKey
        );
    },
    getTemplateConsentPublish(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_CONSENT +
                '/latest-publish/' +
                templateKey
        );
    },
    getTemplateConsentPublishNoSecure(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_CONSENT_NO_SECURE +
                '/latest-publish/' +
                templateKey
        );
    },
    //Add Term & Condition
    getTemplateTermAndCondition(id) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_TERM_AND_CONDITION + `/${id}`
        );
    },
    getTemplateTermAndConditionPublish(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_TERM_AND_CONDITION +
                '/latest-publish/' +
                templateKey
        );
    },
    getTemplateTermAndConditionPublishNoSecure(templateKey) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN_TERM_AND_CONDITION_NO_SECURE +
                '/latest-publish/' +
                templateKey
        );
    },
    addTemplateTermAndCondition(payload) {
        return HttpService.post(
            environment.API_TEMPLATE_DESIGN_TERM_AND_CONDITION,
            payload
        );
    },
    editTemplateTermAndCondition(payload) {
        return HttpService.put(
            environment.API_TEMPLATE_DESIGN_TERM_AND_CONDITION,
            payload
        );
    },
    //List Consent
    searchTemplateDesign(params) {
        return HttpService.get(environment.API_TEMPLATE_DESIGN_CONSENT, {
            params: params,
        });
    },
    deleteTemplate(templateKey) {
        return HttpService.delete(
            environment.API_TEMPLATE_DESIGN + `/${templateKey}`
        );
    },
    downloadFile(payload) {
        return HttpService.post(
            environment.API_TEMPLATE_DESIGN + '/export',
            payload
        );
    },
    //Pubilc
    getPublicTemplateDesign(templateKey) {
        return HttpServiceNoToken.get(
            environment.API_INTEGRATION + `/template/${templateKey}`
        );
    },
    addTemplateAcceptance(payload) {
        return HttpServiceNoToken.post(
            environment.API_INTEGRATION + '/template',
            payload
        );
    },
    addNewTemplateAcceptance(payload) {
        return HttpServiceNoToken.post(
            environment.API_INTEGRATION + '/consent-form/template',
            payload
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(environment.API_TEMPLATE_DESIGN + `/history`, {
            params,
        });
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN + `/history/detail`,
            {
                params,
            }
        );
    },
    createNote(payload) {
        return HttpService.post(
            environment.API_TEMPLATE_DESIGN + '/note',
            payload
        );
    },
    getNotes(payload) {
        return HttpService.get(
            environment.API_TEMPLATE_DESIGN + '/note/' + payload
        );
    },
    editNote(payload) {
        return HttpService.put(
            environment.API_TEMPLATE_DESIGN + '/note',
            payload
        );
    },
    deleteNote(templateDesignId, noteId) {
        return HttpService.delete(
            environment.API_TEMPLATE_DESIGN +
                '/' +
                templateDesignId +
                '/note/' +
                noteId
        );
    },
};
